import React, { Component } from "react";
import "@assets/css/Pages/error-boundary.css"; 
import LogoAltee from "@assets/img/logoAltee.svg";


export default class pageErreur400 extends Component {
  render() {
    return (
      <div className="errorPage_container">
        <div className="d-flex flex-justify-center logo_Altee w-100">
          <img src={LogoAltee} alt="logoAltee" />
        </div>
        <div className="d-flex flex-justify-center w-100">
          <span className="bold number_error">404</span>
        </div>
        <div className="d-flex flex-justify-center w-100">
          <span className="semibold error_description">Page not found</span>
        </div>
      </div>
    );
  }
}
